<template>
    <div class="container">
        <div class="row">
            <div v-if="this.type" class="col-sm-12 col-md-4 col-lg-2">
                <SportSideMenu :type="type" :leagues_list="leagues" @clicked="updatedMatches" />
            </div>
            <div class="col-sm-12 col-md-12 col-lg-10">
                <div class="rit-side-content">
                    <div class="row">
                        <div class="col-sm-12 col-md-12 col-lg-8">

                            <!-- <section class="desktop-bet-detail-sec"> -->
                            <section >
                                <div class="">
                                    <div class="main-heading orange-bg">
                                        <div class="heading-content">
                                            <h1><i class="fa-solid fa-circle-play"></i> {{$t('most-popular','Most Popular')}}</h1>
                                        </div>
                                    </div>
                                </div>
                                <section class="inplay-game-sec" v-if="matches_list?.length > 0">
                                    <div class="inplay-match-list sports-match-list">
                                        <div class="inplay-game-box">
                                            <div class="inplay-item-heading">
                                                <h2>
                                                    <img  class="me-1" :src="getSportImage(type)" alt="game-image">
                                                    <span>{{ matches_list?.league_name ? $t(matches_list?.league_name.toLowerCase(),matches_list?.league_name) : $t(getTitleName().toLowerCase(),getTitleName()) }}</span>
                                                </h2>
                                                <div class="inplay-heading-title">
                                                    <ul>
                                                        <li>1</li>
                                                        <li>X</li>
                                                        <li>2</li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <SportItem :sportsData="matches_list" @save-bets="saveBets"
                                                ref="childComponentRef" />

                                        </div>
                                    </div>
                                    
                                </section>
                                <section v-else>
                                    <section v-if="!$store.getters.globalLoader">
                                        {{$t('no-real-records','No Real-Time Records Found')}}
                                    </section>
                                    
                                </section>
                            </section>
                            <section class="inplay-game-sec upcoming-events-sec" v-if="this.sectionWiseGamesList?.[0].gamesList">
                                <div class="main-heading">
                                    <div class="heading-content">
                                        <h1><span><img src="@/assets/images/exchange.webp"></span> {{$t('exchange-games',' Exchange Games')}}</h1>
                                    </div>
                                </div>
                                <div class="home-exchange-game-list">
                                    <div class="casino-list-item-banner" v-for="item in this.sectionWiseGamesList?.[0].gamesList" @click="clickOnGamestButton(item)">
                                        <figure><a href="javascript:void(0)"><img :src="item.image" class="casino-img" alt="casino-image"></a></figure>
                                    </div>                                    
                                </div>
                            </section>
                            
                            <section class="inplay-game-sec upcoming-events-sec" v-if="this.sectionWiseGamesList?.[1].gamesList">
                                <div class="main-heading">
                                    <div class="heading-content">
                                        <h1><span><img src="@/assets/images/play-cart.webp"></span> {{$t('popular-games',' Popular Games')}} </h1>
                                    </div>
                                </div>
                                <div class="popular-game-wrapper">
                                    <div class="popular-list-item" v-for="item in this.sectionWiseGamesList?.[1].gamesList" @click="clickOnGamestButton(item)">
                                        <figure>
                                            <a href="javascript:void(0)">
                                                <img :src="item.image" class="casino-img" alt="casino-image">
                                                 <!-- <img src="@/assets/images/jili-74.webp"> -->
                                                 <div class="popularGames-item-name">
                                                    <h4>{{ item.game_name }}</h4>
                                                    <span>{{ item.provider }}</span>
                                                 </div>
                                            </a>
                                        </figure>
                                    </div>
                                    
                                </div>
                            </section>

                            <section class="inplay-game-sec upcoming-events-sec" v-if="this.sectionWiseGamesList?.[2].gamesList">
                                <div class="main-heading">
                                    <div class="heading-content">
                                        <h1><span><img src="@/assets/images/play-cart.webp"></span> {{$t('casino-provider',' Casino Provider')}}</h1>
                                    </div>
                                </div>
                                <div class="home-exchange-game-list provider-game-list">
                                    <div class="casino-list-item-banner" v-for="item in this.sectionWiseGamesList?.[2].gamesList" @click="clickOnGamestButton(item)">
                                        <figure>
                                            <a href="javascript:void(0)">
                                                <img :src="item.image" class="casino-img" alt="casino-image">
                                            </a>
                                        </figure>
                                    </div>
                                    
                                </div>
                            </section>   


                           
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-4">

                            <AvailableCredit />

                            <Betslip />
                        </div>
                    </div>
                </div>



            </div>
        </div>
    </div>

    <!-- <TimerBetPlace /> -->
    <div class="cashout-modal-sec">
        <div class="cashout-modal modal fade" id="betplace-modal" tabindex="-1" aria-labelledby="exampleModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="betplace-content">
                            <button type="button" ref="close_timer_btn" style="display:none" class="btn-close"
                                data-bs-dismiss="modal" aria-label="Close"></button>
                            <h4>Your bet is being processed<br> please wait...</h4>
                            <div v-if="delayTimer > 0" class="timer">{{ delayTimer }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="modal fade stake-modal" id="depositModal" tabindex="-1" aria-labelledby="depositModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="deposit-wallet-modal">
                        <div class="wallet-modal-icon">
                            <img loading="lazy" src="@/assets/images/purse.webp">
                        </div>
                        <h4>{{$t('looks-like-your-balance-is-too-low','Looks like your balance is too low')}}</h4>
                        <p>{{$t('deposit-balance-to-continue-playing','Deposit balance to continue playing')}}</p>
                    </div>
                    <div class="deposit-btn-row">
                        <button type="button" data-bs-dismiss="modal" class="btn cancel-btn">{{$t('cancel','Cancel')}}</button>
                        <button type="button" class="btn deposit-btn">{{$t('deposit-balance','Deposit Balance')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div ref="open_confirm_bet_modal" data-bs-toggle="modal" data-bs-target="#betplacing-on" style="display:none"></div>
    <div ref="open_loader_modal" data-bs-toggle="modal" data-bs-target="#betplace-modal" style="display:none"></div>

    <!-- <BetSlipItemDetails :betDetailsItem="betDetails" :eventDetails="eventDetails"/> -->
    <div class="betplacing-modal modal fade" id="betplacing-on" tabindex="-1" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div v-if="betDetails" class="modal-dialog modal-dialog-centered" :class="betDetails?.selection_type=='back'?'betPlacing-pop-back':'betPlacing-pop-lay'">
            <div  class="modal-content">
                <div class="modal-body">
                    <div class="betplace-team-title">
                        <h4>{{ betDetails?.event_name }}</h4>
                        <h5>{{ betDetails.selection_type }}ing <strong>{{ betDetails.runner_name }}</strong></h5>
                    </div>
                    <div class="betplace-stake-wrapper">
                        <div class="stake-odds">
                            <h4><span>ODDS</span>{{ $helper.formatNumber(betDetails.odds) }}</h4>
                        </div>
                        <div class="stake-odds">
                            <h4><span>STAKE</span>{{ $helper.formatNumber(betDetails.stake) }}</h4>
                        </div>
                        <div class="stake-odds">
                            <h4><span>Profit</span>{{ $helper.formatNumber(betDetails.pl) }}</h4>
                        </div>
                    </div>
                    <ul class="cmn-ul-list">
                        <li class="betslip-btn">
                            <button ref="dismiss_confirm_bet_placing" data-bs-dismiss="modal" class="btn btn-outline-primary" type="button">Cancel</button>
                        </li>
                        <li class="betslip-btn">
                            <button @click="saveBets()" data-bs-dismiss="modal"
                                class="btn btn-secondary ready-place-bet-btn">
                                <div class="BetPlacing__col">
                                    <div class="place-bet-text">Place Bet</div>
                                    <div class="BetPlacing__profit">Profit:{{ $helper.formatNumber(betDetails.pl) }}</div>
                                </div>
                                <div class="BetPlacing__delay"><i class="fa fa-stopwatch"></i>5s</div>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>


    </div>
    <div ref="open_login_modal" style="display: none;" data-bs-toggle="modal" data-bs-target="#login-casino-btn">
    </div>

    <div ref="games_pop_1_modal" style="display: none;" data-bs-toggle="modal" data-bs-target="#static_games_pop_1">
    </div>

    <div ref="games_pop_2_modal" style="display: none;" data-bs-toggle="modal" data-bs-target="#static_games_pop_2">
    </div>

    <div ref="iframe_pop_modal_home" style="display: none;" data-bs-toggle="modal" data-bs-target="#iframe_pop_modal_home">
    </div>


    <div class="modal fade game-play-modal" data-bs-backdrop="static" data-bs-keyboard="false" id="iframe_pop_modal_home" tabindex="-1" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-fullscreen" style="max-width: 100%;">
            <IFrameModal @close-modal="openIframeModal=false" v-if="openIframeModal"/>
        </div>

    </div>
</template>
<script>

import * as constants from '../utils/constants.js';
import click_api from '../services/click_api';
import * as apiName from '../services/urls';
import { setGameItem } from "@/shared/constants/shared-data";

import api from '../services/api';
import { ref } from 'vue';
import { defineAsyncComponent } from 'vue';
import { mapGetters } from 'vuex';

export default {
    name: "Sports",
    components: {
        Banner: defineAsyncComponent(() =>
            import('@/shared/components/banner/Banner.vue')
        ),
        SportItem: defineAsyncComponent(() =>
            import('../components/SportItem.vue')
        ),
        SportSideMenu: defineAsyncComponent(() =>
            import('../components/SportSideMenu.vue')
        ),
        AvailableCredit: defineAsyncComponent(() =>
            import('@/shared/components/available-credit/AvailableCredit.vue')
        ),
        Betslip: defineAsyncComponent(() =>
            import('@/shared/components/bet-slip/BetSlip.vue')
        ),
        IFrameModal: defineAsyncComponent(() =>
            import('@/modules/games/components/IFrameModal.vue')
        ),
    },
    data() {
        return {
            items: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
            constants: constants,
            type: this.$route.params.type,
            sport_id: this.$route.params.id,
            matches_list: [],
            favouriteList: this.$store.getters.favouriteGames,
            leagues: {},
            betDetails: null,
            betCloseSetTimeOut: null,
            delayTimer: 0,
            eventManage: null,
            openIframeModal: false,
            sectionWiseGamesList: [
                {
                    slugName: 'home-section',
                    gamesList: null,
                    seeAll: false,
                    defaultGames: 5,
                },
                {
                    slugName: 'popular-games',
                    gamesList: null,
                    seeAll: false,
                    defaultGames: 5,
                },
                {
                    slugName: 'home-screen-casino',
                    gamesList: null,
                    seeAll: false,
                    defaultGames: 5,
                }
            ],
            gamesData: null,
            sectionsList: null,
            recommendedGameList: null,
            favouriteGamesList: this.$store.getters.favouriteGames,

        }
    },
    computed: {
        ...mapGetters(['getSportImage'])
    },
    created() {
        this.get_sportsList();        
		this.eventManage = this.$store?.getters?.eventManage;
    },
    setup() {
        // Define a ref to hold the child component instance
        const childComponentRef = ref(null);

        // Expose the ref to the template
        return {
            childComponentRef
        };
    },
    mounted(){
        // this.getCasinoGamesServiceCall();
    },
    methods: {
        checkInEventMangeForGame(typeId, gameCode, LockedProvider, LockedProviderGames)
        	{
            	return (LockedProvider?.length || LockedProviderGames?.length) ? !(LockedProviderGames.includes(gameCode.toString())) && !(LockedProvider.includes(typeId.toString())) :true;
        	},
        setSectionList() {
				try {
					for (let i = 0; i < this.sectionsList?.length; i++) {
						let gamesList = [];
						if (this.sectionsList[i]?.menus) {
							for (let j = 0; j < this.sectionsList[i].menus?.length; j++) {
								gamesList = gamesList.concat(this.sectionsList[i]?.menus[j]?.games);
							}
						} else {
							gamesList = this.sectionsList[i].games;
						}

						let gameListNew = [];
						if(this.checkIsLogin()) {
							
							let LockedProvider = this.eventManage?.find(item => item.type == 'casino-provider');
							let LockedProviderGames = this.eventManage?.find(item => item.type == 'provider-game');
							LockedProvider = LockedProvider && LockedProvider.type_id !== null ? LockedProvider.type_id.split(',') : [];
							LockedProviderGames = LockedProviderGames && LockedProviderGames.type_id !== null ? LockedProviderGames.type_id.split(',') : [];

							for(var k=0;k<gamesList?.length;k++){
                                if(this.favouriteGamesList.includes(gamesList[k].id)){
                                    gamesList[k]['favourite']=true
                                }else{
                                    gamesList[k]['favourite']=false
                                }
								
								if(this.checkInEventMangeForGame(gamesList[k].provider_id,gamesList[k].id, LockedProvider, LockedProviderGames))
								{
									gameListNew.push(gamesList[k]);
								}
                            }
						} else {
							gameListNew = gamesList;
						}
						const naturalCollator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
						gameListNew.sort((a, b) => naturalCollator.compare(a.porder, b.porder));

						switch (this.sectionsList[i].slug) {
							case 'home-section':
								this.sectionWiseGamesList[0].gamesList = gameListNew;
								break;
							case 'popular-games':
								this.sectionWiseGamesList[1].gamesList = gameListNew;
								break;
							case 'home-screen-casino':
								this.sectionWiseGamesList[2].gamesList = gameListNew;
								break;							
						}
					}

				} catch (error) {
					console.log(error);
				}
		},
        getCasinoGamesServiceCall() {
            let casinoData = this.$store.getters.gamesData;
            this.gamesData = casinoData;
            this.sectionsList = casinoData.sections;
            this.recommendedGameList = casinoData?.recommended_games;
            this.setSectionList();
        },
        clickOnGamestButton(item) {
            if (this.$auth.status) {
                this.openGamesPopup(item);
            }
            else {
                this.$helper.openModal('#login-casino-btn');
            }
        },
        userData() {
            return this.$store.getters.stateUser;
        },
        openGamesPopup(gameItem) {
            setGameItem(gameItem);
            switch (this.$auth.user.currency) {
                case 1:
                    if (gameItem.only_hkd == 1) {
                        this.$refs.games_pop_1_modal.click();
                    }
                    else if (gameItem.only_hkd == 0) {
                        this.openIframeModal = true;
                        this.$refs.iframe_pop_modal_home.click();
                    }
                    break;
                case 2:
                    if (gameItem.only_hkd == 1) {
                        this.$refs.games_pop_1_modal.click();
                    }
                    else if (gameItem.only_hkd == 0) {
                        this.$refs.games_pop_2_modal.click();
                    }
                    break;
                case 3:
                case 4:
                    this.openIframeModal = true;
                    this.$refs.iframe_pop_modal_home.click();
                    break;
            }
        },
        checkForLockedMatches(matchId, league_id, lockedMatchIds, lockedLeagueIds) {
            return this.checkIsLogin() && (lockedMatchIds?.length || lockedLeagueIds?.length) ? !lockedMatchIds.includes(matchId.toString()) && !lockedLeagueIds.includes(league_id.toString()) : true
        },
        get_sportsList() {
            this.loading = true;
            this.$store.dispatch('setGlobalLoader',true)
            click_api.get(apiName.MATCHES_BY_SPORT_ID + this.sport_id).then(response => {
                this.loading = false;
                this.$store.dispatch('setGlobalLoader',false)
                if (response) {
                    if (response.status == 200) {

                        try {
                            this.matches_list = response.data.data
                            let lockedMatchIds = [];
                            let lockedLeagueIds = [];
                            if(this.checkIsLogin() && this.eventManage) {
                                lockedMatchIds = this.eventManage.find(item => item.type == 'match');
                                lockedLeagueIds = this.eventManage.find(item => item.type == 'league');

                                lockedMatchIds = lockedMatchIds && lockedMatchIds.type_id !== null ? lockedMatchIds.type_id.split(',') : [];
                                lockedLeagueIds = lockedLeagueIds && lockedLeagueIds.type_id !== null ? lockedLeagueIds.type_id.split(',') : []
                            }
                            for (var i = this.matches_list?.length - 1; i >= 0; i--) {
                                if(this.checkForLockedMatches(this.matches_list[i].matchId, this.matches_list[i].league_id, lockedMatchIds, lockedLeagueIds)) {
                                    if (this.favouriteList.length && this.favouriteList.includes(parseInt(this.matches_list[i].event_id))) {
                                        this.matches_list[i]['favourite'] = true
                                    } else {
                                        this.matches_list[i]['favourite'] = false
                                    }
                                } else {
                                    this.matches_list.splice(i, 1)
                                }
                            }

                            this.matches_list?.forEach(item => {
                                const leagueName = item.league_name;
                                if (!this.leagues[leagueName]) {
                                    this.leagues[leagueName] = [];
                                }
                                this.leagues[leagueName].push(item);
                            });

                        }
                        catch (error) {
                        }

                    }
                }
            }).catch(error => {
                this.loading = false;
                this.$store.dispatch('setGlobalLoader',false)
                if (error) {
                    this.$errorToast(error[0]);;
                }
            });
        },

        checkIsLogin() {
            return this.$store.getters.isAuthenticated;
        },
        updatedMatches(value) {
            this.matches_list = value;
        },
        openSportEventDetailPage() {
            this.$router.push({ name: 'sports-event-detail', params: { type: this.type } })
        },
        getTitleName() {
            switch (this.type) {
                case this.constants.CRICKET:
                    return 'Cricket';
                case this.constants.FOOTBALL:
                    return 'Football';
                case this.constants.TENNIS:
                    return 'Tennis';
                case this.constants.SOCCER:
                    return 'Football';
                default:
                    return this.type;
            }
        },


        saveBets(betDetails, validate = 1, showBetSlipDetail = false) {
            if (betDetails)
                this.betDetails = betDetails;
            if (!this.betDetails.stake || !this.betDetails.odds) {
                this.$errorToast('Stake field is required!');
                return;
            }


            this.betDetails.validate = validate;
            if (!this.betDetails.accept_any_odds) {
                this.betDetails.accept_any_odds = 0;
            }
            if (this.betDetails.betLoader && validate) {
                return;
            }

            if (showBetSlipDetail && this.confirmBetPlacingChange()) {
                this.$refs.open_confirm_bet_modal.click();
                return;
            }

            this.$refs.open_loader_modal.click();
            this.betDetails.bet_user_guid = Math.random().toString(36);
            this.betDetails.betLoader = true;
            clearInterval(this.betCloseSetTimeOut);
            api.post(apiName.SAVE_BETS, this.betDetails).then(response => {
                if (response) {
                    if (response.status == 200 && response.data.data.bet_delay) {
                        this.delayTimer = response.data.data.bet_delay;
                        setTimeout(function () {
                            this.saveBets(undefined, 0);
                        }.bind(this), response.data.data.bet_delay * 1000)
                    } else if (response.status == 200) {
                        this.$refs.close_timer_btn.click();
                        let user = this.$store.getters.stateUser;
                        user.exposure = response.data.data.total_exposure;
                        this.$store.dispatch('setUser', user);
                        this.cancleBetSlip()
                        this.$successToast(response.data.message);
                    } else {
                        this.$refs.close_timer_btn.click();
                        this.betDetails.bet_time = Math.round(Date.now() / 1000);
                        this.counterStartForCloseBet();
                        this.betDetails.betLoader = false;
                        this.$errorToast(response.data.message);
                    }
                }
            }).catch(error => {
                this.betDetails.betLoader = false;
                this.$refs.close_timer_btn.click();
                if (error) {
                    this.betDetails.bet_time = Math.round(Date.now() / 1000);
                    this.counterStartForCloseBet();
                    this.$errorToast(error?.[0]);
                }
            });
        },

        confirmBetPlacingChange() {
            return localStorage.getItem('CONFIRM_BET_PLACING') == 'true' ? true : false;
        },
        counterStartForCloseBet() {
            clearInterval(this.betCloseSetTimeOut);
            this.betCloseSetTimeOut = setInterval(() => {
                var current_time = Math.round(Date.now() / 1000);
                if (current_time - this.betDetails.bet_time > 9) {
                    this.cancleBetSlip();
                }
            }, 1000);
        },

        cancleBetSlip() {
            this.betDetails = null;
            clearInterval(this.betCloseSetTimeOut);
            // close cashout modal
            //this.$refs.closeCashoutModal.click();
            this.$refs?.dismiss_confirm_bet_placing.click();
            if (this.childComponentRef.value) {
                // Call the function on the child component
                this.childComponentRef.value.cancleBetSlip();
            }

        },
    }
};
</script>